import { NgModule } from '@angular/core';
import { LoaderComponent } from './loader.component';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { OverlayModule } from 'angular-io-overlay/src/overlay';

@NgModule({
    declarations: [
        LoaderComponent
    ],
    imports: [
        BrowserModule,
        CommonModule,
        OverlayModule
    ],
    exports: [
        LoaderComponent
    ]
})
export class LoaderModule {}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/shared/components/loader/loader.module.ts